import auth from "@/services/LandingInitAuth"

const list = () =>
  auth.get(`${process.env.VUE_APP_LANDING_ADMIN_API}cities/`);

export default {
  list,
}